<template>
  <div class="BC-container">

    <div class="BC-right-container">
      <div>
        <h3 style="margin-left: 30px">配件条形码打印：</h3>
        <div  class="floating-link">
          <a href="https://mangkeyi.yuque.com/tluy7x/rpi080/yv7qrecpy22tw1yc" target="_blank">使用教程</a>
        </div>
        <div style="width:320px">
          <el-form size="small" :model="form" :rules="rules" ref="form" label-width="120px" style="margin-top:20px">
            <el-form-item label="适用机型" prop="applicableModels" style="margin-left: -20px">
              <!-- <el-select v-model="form.applicableModels" filterable placeholder="适用机型" v-el-select-loadmore="selectLoadMoreSnInfo" style="width: 160px; height: 25px">
                <el-option
                  v-for="(data, index) in Array.from(new Set(this.phoneNameList))"
                  :key="index"
                  :value="data"
                  :label="data"
                ></el-option>
              </el-select> -->
              <el-select
                filterable
                v-model="form.applicableModels"
                placeholder="适用机型"
                style="width: 210px; height: 40px; "
                v-el-select-loadmore="selectLoadMoreSnInfo"
              >
                <el-option
                  v-for="(data, index) in Array.from(new Set(this.phoneNameList))"
                  :key="index"
                  :value="data"
                  :label="data"
                ></el-option> </el-select
              >
            </el-form-item>
            <el-form-item label="配件类型" prop="fitType" style="margin-left: -20px;">
              <el-select v-model="form.fitType" placeholder="配件类型" style="width: 210px; height: 40px; ">
                <el-option
                  v-for="(data, index) in options"
                  :key="index"
                  :value="data"
                  :label="data"

                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="条形码份数" prop="barCodeNum" style="margin-left: -20px">
              <el-input v-model.number="form.barCodeNum" style="width: 212px" ></el-input>
            </el-form-item>
            <div class="tipsDemo">
              {{ tips }}
            </div>
            <el-form-item>
              <el-button style="float:left; margin-top: 20px; margin-left: 150px; height: 36px; width: 140px" type="primary" :disabled="isButtonDisabled" size="small" @click="submitBarcodeNum('form')">批量生成条形码</el-button>
            </el-form-item>
            <el-form-item>
              <el-button style="margin-top:-54px;float: left; margin-left: 350px; height: 36px; width: 140px" @click="obtainBarcodeInformation" type="primary" size="small" v-loading.fullscreen.lock="fullscreenLoading"
                >条形码打印</el-button>
              <!-- <el-button type="primary" :disabled="isButtonDisabled" size="small" @click="submitBarcodeNum('form')">批量生成条形码</el-button> -->
            </el-form-item>
          </el-form>
        </div>

      </div>
    </div>
    <!-- <el-dialog
      title="入库"
      :visible.sync="warehousingVisible"
      width="50%"
      :before-close="handleClose"
    >
      <div>
        <el-input type="textarea" :rows="12" v-model="scanBarcodeIn"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="warehousingVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitScanInData">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>
<script>
import axios from "axios";
import Socket from "@/utils/Socket";
import NMPrintSocket from "@/utils/Print";
import { batchPrintData } from "@/utils/printData/Batch";
export default {
  //创建自定义事件
  directives: {
    "el-select-loadmore": {
      bind(el, binding) {
        const SELECTWRAP_DOM = el.querySelector(
          ".el-select-dropdown .el-select-dropdown__wrap"
        );
        SELECTWRAP_DOM.addEventListener("scroll", function () {
          const rect = this.getBoundingClientRect();
          const isAtBottom = rect.bottom <= window.innerHeight;
          if (isAtBottom) {
            binding.value();
          }
        });
      },
    },
  },
  data() {
    const jsonObj = {
      printerImageProcessingInfo: {
        printQuantity: 1,
      },
    };
    return {
      fitTypeTitle:'',
      fitTypeQueId:'',
      printNumTitle:'',
      printNumQueId:'',
      autoComputeTitle:'',
      autoComputeQueId:'',
      fitTypeNameTitle:'',
      fitTypeNameQueId:'',
      applicationNameTitle:'',
      applicationNameQueId:'',
      form: {
        applicableModels: '',
        fitType: '',
        barCodeNum: null,
      },
      rules: {
        fitType: [
          { required: true, message: '请选择配件类型', trigger: 'change' },
        ],
        barCodeNum: [
          { required: true, message: '请输入条形码份数', trigger: 'blur' },
          { type: 'number', message: '条形码份数必须是数字', trigger: 'blur' },
        ],
      },
      fullscreenLoading:false,
      isButtonDisabled:false,
      tips: '',
      items: [],
      newItem: "",
      fitType: "",
      applicableModels: "",
      fitTypePrint: "",
      barCodeNum: "",
      warehousingVisible: false,
      scanBarcodeIn:[],
      jsonObj,
      // 打印服务是否连接成功
      printSocketOpen: false,
      batchPrintData,
      barCodeList: [],
      barCodePrintList: [],
      barcodePrintFlag: false,
      nMPrintSocket: null,
      usbPrinters: {},
      usbSelectPrinter: "",
      onlineUsbBool: false,
      initBool: false,
      responseflag: false,
      density: 3,
      label_type: 1,
      print_mode: 1,
      options: [],
      phoneNameList: [],
      currentPage: 1,
      pageSize: 200,
      pageAmount: 1,
      partsPage: 1,
      partsSize: 200,
      partsAmount: 1,
      isExist:0,
      //已经打印的配件编码
      codes:[],
      code:0,
      userId:1940693
    };
  },
  mounted() {
    // 创建socket实例
    const socketData = new Socket("ws://127.0.0.1:37989");

    socketData.open(
      (openBool) => {
        this.printSocketOpen = openBool;
      },
      (msg) => {
        if (msg.resultAck.callback != undefined) {
          const callbackName = msg.resultAck.callback.name;
          const msgInfo = msg.resultAck.info;
          if (callbackName == "onCoverStatusChange") {
            //盒盖状态：0-闭合、1-打开
            console.log("盒盖状态", msgInfo.capStatus);
          } else if (callbackName == "onElectricityChange") {
            //"power" : 0-4, // 电池电量等级（共5档）
            console.log("电池电量等级", msgInfo.power);
          }
        }
      }
    );
    // 创建打印实例
    this.nMPrintSocket = new NMPrintSocket(socketData);
  },
  created() {
    this.login();

  },
  methods: {
    login() {
      const currentUrl = window.location.toString();
      const urlObject = new URL(currentUrl);
      const searchParams = new URLSearchParams(urlObject.search);
      const userId = searchParams.get("qfExtUserId");
      if(userId != null || userId != undefined){
        this.userId = userId;
      }
      console.log(this.userId);
      // 创建一个新的 Axios 实例专用于 /orderListApi 请求
      const loginApiInstance = axios.create({
        baseURL: "/loginApi",
      });
      //使用FormData对象发送POST请求
      loginApiInstance
        .get("monkeyshop/user/login/" + this.userId)
        .then((res) => {
          // this.tableData = res.data.data;
          if (res.data.code == 200) {
            this.obtainPJInfo();
            this.obtainPhoneInfo();
          }else{
            alert(res.data.msg);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    printTest(){
    },
    async print(content) {
      this.fullscreenLoading = true;
      const allPrintersRes = await this.nMPrintSocket.getAllPrinters();
      try {
        if (allPrintersRes.resultAck.errorCode === 0) {
          const allPrinters = JSON.parse(allPrintersRes.resultAck.info);
          const allPrintersName = Object.keys(allPrinters);
          const allPrintersValue = Object.values(allPrinters);

          const res = await this.nMPrintSocket.selectPrinter(
            allPrintersName[0],
            parseInt(allPrintersValue[0])
          );

          if (res.resultAck.errorCode === 0) {
            console.log("连接成功");
            const initRes = await this.nMPrintSocket.initSdk({ fontDir: "" });
            if (initRes.resultAck.errorCode == 0) {
              console.log("初始化成功");
              this.startBatchPrintJobTest(content);
            } else {
              this.fullscreenLoading = false
              this.$notify.error({
                  title: '错误',
                  message: '初始化失败'
              });
              console.log("初始化失败");
            }
          } else {
            this.fullscreenLoading = false
            this.$notify.error({
              title: '错误',
              message: '连接失败'
            });
            console.log("连接失败");
            alert("连接失败");
          }
        } else {
          this.fullscreenLoading = false
          return alert("没有在线的打印机");
        }
      } catch (err) {
        return alert(err);
      }
    },

    // 下拉列表触底事件
    selectLoadMoreSnInfo() {
      this.currentPage += 1;
      this.obtainPhoneInfo();
    },

    obtainPhoneInfo() {
      if(this.currentPage <= this.pageAmount){
        let params = {
        userId: this.userId,
        pageSize: this.pageSize,
        pageNum: this.currentPage,
      };
      const searchPhoneInfo = axios.create({
        baseURL: "/colorListApi",
        "Content-Type": "application/json",
      });
      searchPhoneInfo
        .post("monkeyshop/common/searchPhoneInfo",params)
        .then((res) => {
          console.log("手机信息",res);
          this.pageAmount = res.data.data.pageAmount;
          res.data.data.phoneNameList.forEach((element) => {
            this.phoneNameList.push(element);
          });
        })
        .catch(function (error) {
          console.log(error);
        });
      }
    },
    //更新打印机列表
    async getPrinters() {
      if (!this.printSocketOpen) {
        this.fullscreenLoading = false
        return alert("打印服务未开启");
      }
      console.log("开始获取打印机");
      try {
        const allPrintersRes = await this.nMPrintSocket.getAllPrinters();
        console.log(allPrintersRes, "allPrintersRes");
        if (allPrintersRes.resultAck.errorCode === 0) {
          const allPrinters = JSON.parse(allPrintersRes.resultAck.info);
          this.usbPrinters = { ...allPrinters };
          this.usbSelectPrinter = Object.keys(this.usbPrinters)[0];
          console.log("printers", this.usbPrinters);
        } else {
          this.fullscreenLoading = false
          alert("没有在线的打印机");
        }
      } catch (err) {
        console.error(err);
      }
    },
    // 连接打印机
    async selectOnLineUsbPrinter() {
      if (!this.printSocketOpen) {
        this.fullscreenLoading = false
        return alert("打印服务未开启");
      }
      console.log("开始连接打印机");
      try {
        const res = await this.nMPrintSocket.selectPrinter(
          this.usbSelectPrinter,
          parseInt(this.usbPrinters[this.usbSelectPrinter])
        );
        console.log("选择打印机", res);

        if (res.resultAck.errorCode === 0) {
          console.log("连接成功");
          this.onlineUsbBool = true;
        } else {
          console.log("连接失败");
          this.onlineUsbBool = false;
          this.fullscreenLoading = false
          this.$notify.error({
            title: '错误',
            message: '连接失败'
          });
          // alert("连接失败");
        }
      } catch (err) {
        console.error(err);
      }
    },
    //初始化SDK
    async init() {
      if (!this.printSocketOpen) return alert("打印服务未开启");
      //初始化数据
      try {
        const res = await this.nMPrintSocket.initSdk({ fontDir: "" });
        if (res.resultAck.errorCode == 0) {
          console.log("初始化成功");
          this.initBool = true;
        } else {
          console.log("初始化失败");
          this.initBool = false;
          this.fullscreenLoading = false
          this.$notify.error({
            title: '错误',
            message: '初始化失败'
          });
        }
      } catch (err) {
        console.error(err);
      }
    },
    // 开始批量打印
    async startBatchPrintJobTest(content) {
      // console.log(this.batchPrintData.data,'batchPrintData')
      // this.batchPrintData.data = content
      if (!this.printSocketOpen) return alert("打印服务未开启");
      if (content == null || content.length == 0) {
        return;
      }
      this.batchPrintJob(content.data);
      // this.batchPrintJob(content);
    },
    //批量打印列表数据
    async batchPrintJob(list) {
      const printQuantity =
        this.jsonObj.printerImageProcessingInfo.printQuantity;
      try {
        const startRes = await this.nMPrintSocket.startJob(
          this.density,
          this.label_type,
          this.print_mode,
          list.length * printQuantity
        );
        if (startRes.resultAck.errorCode == 0) {
          // 提交打印任务
          await this.printTag(list, 0);
        }
      } catch (err) {
        console.error(err);
      }
    },
    // 绘制打印标签
    async printTag(list, x) {
      //设置画布尺寸
      try {
        const res = await this.nMPrintSocket.InitDrawingBoard(
          list[x].InitDrawingBoardParam
        );
        if (res.resultAck.errorCode != 0) {
          return;
        }
        // 提交打印任务
        this.printItem(list, x, list[x].elements, 0);
      } catch (err) {
        console.error(err);
      }
    },
    async printItem(list, x, item, i) {
      var that = this;
      that.code = list[x].applyId;
      try {
        if (i < item.length) {
          let arrParse;
          switch (item[i].type) {
            case "text":
              //绘制文本
              arrParse = await this.nMPrintSocket.DrawLableText(item[i].json);
              if (arrParse.resultAck.errorCode != 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i);
              break;
            case "qrCode":
              arrParse = await this.nMPrintSocket.DrawLableQrCode(item[i].json);
              //绘制二维码
              if (arrParse.resultAck.errorCode !== 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i);
              break;
            case "barCode":
              //绘制一维码
              arrParse = await this.nMPrintSocket.DrawLableBarCode(
                item[i].json
              );
              if (arrParse.resultAck.errorCode !== 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item);
              break;
            case "line":
              //绘制线条
              arrParse = await this.nMPrintSocket.DrawLableLine(item[i].json);
              if (arrParse.resultAck.errorCode !== 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i);
              break;
            case "graph":
              //绘制边框
              arrParse = await this.nMPrintSocket.DrawLableGraph(item[i].json);
              if (arrParse.resultAck.errorCode != 0) {
                return;
              }

              i++;
              await this.printItem(list, x, item, i);
              break;
            case "image":
              //绘制边框
              arrParse = await this.nMPrintSocket.DrawLableImage(item[i].json);
              if (arrParse.resultAck.errorCode != 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i);
              break;
          }
        } else {
          //遍历完成，开始打印
          const commitRes = await this.nMPrintSocket.commitJob(
            null,
            JSON.stringify(this.jsonObj)
          );
          //回调页码为数据总长度且回调打印份数数据等于当前页需要打印的份数数据时，结束打印任务
          // if (
          //   commitRes.resultAck.printQuantity == list.length &&
          //   commitRes.resultAck.onPrintPageCompleted ==
          //     this.jsonObj.printerImageProcessingInfo.printQuantity
          // ) {

            // //结束打印任务
            // const endRes = await this.nMPrintSocket.endJob();
            // if (endRes.resultAck.errorCode === 0) {
            //   console.log("打印完成",endRes);
            //   this.submitScanInData()
            // }else{
            //   console.log("打印失败");
            // }
            // return;
          // }
          //回调为提交成功，同时数据未发送完成时，可继续提交数据

          if (commitRes.resultAck.errorCode == 0) {
            that.codes.push(that.code);
            console.log("配件ID",that.code);
            if(x < list.length - 1){
              console.log("发送下一页打印数据： ");
              x++;
              await this.printTag(list, x);
            }else{
              console.log("结束打印");
              console.log("已打印配件",that.codes);
              const endRes = await this.nMPrintSocket.endJob();
              this.submitScanInData()
            }
          }else{
            console.log("打印失败");
            console.log("已打印配件",that.codes);
            const endRes = await this.nMPrintSocket.endJob();
            this.submitScanInData()
          }
        }
      } catch (err) {
        console.error(err,'打印出错ERR');
      }
    },
    submitBarcodeNum(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var that = this;
          let params = {
            partsType: that.form.fitType,
            partsNum: that.form.barCodeNum,
            partsModel: that.form.applicableModels,
            userId: this.userId
          };
          const searchPhoneInfo = axios.create({
            baseURL: "/colorListApi",
            "Content-Type": "application/json",
          });
         searchPhoneInfo
          .post("monkeyshop/common/savePartsBarcode",params)
          .then((res) => {
              that.$notify({
                title: "请求成功",
                message: "提交条形码信息成功",
                type: "success",
              });
              if(that.form.applicableModels){
                that.newItem =
                "已生成适用于" +
                that.form.applicableModels +
                "的" +
                that.form.fitType +
                that.form.barCodeNum +
                "份";
                that.tips = that.newItem;
              }else{
                that.newItem =
                "已生成" +
                that.form.fitType +
                that.form.barCodeNum +
                "份";
                that.tips = that.newItem;
              }

              console.log(res, "res");
              // this.obtainBarcodeInformation();
              that.isButtonDisabled = true
              that.form.fitType = ''
              that.form.applicableModels = ''
              that.form.barCodeNum = ''
              that.$nextTick(() => {
                that.$refs["form"].clearValidate();
              });
              that.$forceUpdate();
            })
            .catch(function (error) {
              console.log(error);
            });
          // alert('提交成功！');
          // 这里可以执行提交表单的实际逻辑
        } else {
          console.log('表单验证失败！');
          return false;
        }
      });
    },

    obtainBarcodeInformation() {
      var that = this;
      that.barCodePrintList = [];
      let params = {
            userId: this.userId
          };
          const searchPhoneInfo = axios.create({
            baseURL: "/colorListApi",
            "Content-Type": "application/json",
          });
         searchPhoneInfo
        .post("monkeyshop/common/searchNotParts",params)
        .then((res) => {
          console.log("配件列表:",res);
          that.barCodeList = res.data.data;
          let length = that.barCodeList.length;
          for (var i = 0; i < length; i++) {
            let item = that.barCodeList[i];
            let codeValue = item.partCode;

            that.scanBarcodeIn.push(codeValue)

            let PJnameValue = item.partName;

            let PJApplication = item.partModel;
            if (codeValue !== undefined) {
              const printbarData = {
                InitDrawingBoardParam: {
                  width: 40,
                  height: 30,
                  rotate: 0,
                  path: "ZT001.ttf",
                  verticalShift: 0,
                  HorizontalShift: 0,
                },
                applyId:0,
                elements: [
                  {
                    type: "text",
                    json: {
                      x: 2,
                      y: 2,
                      height: 4.3,
                      width: 34,
                      value: "数据线",
                      codeType: 20,
                      rotate: 0,
                      fontSize: 2.6,
                      textHeight: 3.2,
                      textPosition: 0,
                    },
                  },
                  {
                    type: "barCode",
                    json: {
                      x: 2,
                      y: 8,
                      height: 15,
                      width: 30,
                      value: "0000001",
                      codeType: 20,
                      rotate: 0,
                      fontSize: 3.2,
                      textHeight: 3.2,
                      textPosition: 0,
                    },
                  },
                ],
              };
              if(PJApplication == undefined){
                printbarData.elements[0].json.value = PJnameValue;
              }else{
                printbarData.elements[0].json.value = PJApplication + PJnameValue;
              }
              printbarData.elements[1].json.value = codeValue;
              printbarData.applyId = item.applyId;
              that.barCodePrintList.push(printbarData);
            }
            if(i == length - 1 && that.barCodePrintList.length > 0){
              that.$notify({
                title: "请求成功",
                message: "获取条形码信息成功",
                type: "success",
              });

            }
          }
          that.batchPrintData.data = that.barCodePrintList;
          console.log("打印数据",that.batchPrintData);
          that.print(that.batchPrintData)
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    toWarehousing() {
      this.warehousingVisible = true;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    submitScanInData() {
      var that = this;
      let params = {
        userId: this.userId,
        codes:that.codes
      };
      const searchPhoneInfo = axios.create({
        baseURL: "/colorListApi",
        "Content-Type": "application/json",
      });
        searchPhoneInfo
      .post("monkeyshop/common/warehousingParts",params)
      .then((res) => {
        console.log("修改结果",res);
        if(res.data.code == 200){

          that.fullscreenLoading = false
          that.isButtonDisabled = false;
          console.log(that.codes.length);
          console.log(that.barCodeList.length);
          let num = that.barCodeList.length - that.codes.length;
          console.log(num);
          that.newItem =
            "本次打印成功"+that.codes.length+"份，打印失败" +num+"份";
          console.log(that.newItem);
          that.tips = that.newItem;
          that.codes = [];
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    obtainPJInfo() {
      this.options = [];
      if(this.partsPage <= this.partsAmount){
      let params = {
        userId: this.userId,
        pageSize: this.partsSize,
        pageNum: this.partsPage,
      };
      const searchPhoneInfo = axios.create({
        baseURL: "/colorListApi",
        "Content-Type": "application/json",
      });
      searchPhoneInfo
        .post("monkeyshop/common/searchPartsInfo",params)
        .then((res) => {
          console.log("配件信息",res);
          this.partsAmount = res.data.data.pageAmount;
          res.data.data.partsList.forEach((element) => {
            this.options.push(element);
          });
        })
        .catch(function (error) {
          console.log(error);
        });
      }
    },
  },
};
</script>
<style scoped>
.BC-container{
  background-color: rgba(255,235,219,0.27);
    display: flex;
    width: 100%;
    height: 400px;
}
.BC-left-container {
  background-color: #d9ecff;
  width: 48%;
  margin: 25px;
  padding: 2%;
  border-radius: 20px;
}
.BC-right-container {
  position: relative; /* 设置容器为相对定位 */
  background-color: #FFFFFF;
  height: 300px;
  width: 98%;
  margin: 25px;
  padding: 2%;
  border-radius: 20px;
}
.floating-link {
  position: absolute; /* 绝对定位 */
  top: 10px; /* 距离容器顶部的距离 */
  right: 180px; /* 距离容器右边的距离 */
}
h3 {
  text-align: left;
}
.tipsDemo {
  /* background-color: #f0f9eb; */
  width: 300rpx;
  color: #67c23a;
}
.el-button--primary {
  color: #fff;
  background-color: #fb9337;
  border-color: #fb9337;
}
.el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
    color: #FFF;
    background-color: #f3d19e;
    border-color: #f3d19e;
}
</style>



// WEBPACK FOOTER //
// src/views/SNPage.vue